import { AlarmItem, TemplateAlarmTableProps } from '@/template/interface'
import { getAddressName } from '@/utils/dataType'
import { getFormatMessage, mergeTableColumns } from '@/utils/utils'
import { Space, Table } from 'antd'
import React from 'react'

export const TemplateAlarmTable: React.FC<TemplateAlarmTableProps> = (
  props: TemplateAlarmTableProps
) => {
  const formatMessage = getFormatMessage()
  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.template.alarm.table.index' }),
      key: 'app.template.alarm.table.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.template.alarm.table.name' }),
      key: 'app.template.alarm.table.name',
      dataIndex: 'name'
    },
    {
      title: formatMessage({ id: 'app.template.alarm.table.condition' }),
      key: 'app.template.alarm.table.condition',
      render: (text: any, record: AlarmItem, index: any) => {
        const variable = props.variables?.find((x) => x.id == record.variableId)
        if (variable) {
          if (variable.dataType == 0) {
            return record.operate1 == 1 ? 'ON' : 'OFF'
          }
          const c1 = formatMessage({
            id: `app.template.alarm.condition.${record.condition1}`
          })
          const v = formatMessage({ id: 'app.template.alarm.value' })
          if (record.condMethod && record.condMethod > 0) {
            const c2 = formatMessage({
              id: `app.template.alarm.condition.${record.condition2}`
            })
            const m = formatMessage({
              id: `app.template.alarm.conditionMethod.${record.condMethod}`
            })

            return `${v} ${c1}${record.operate1} ${m} ${v} ${c2}${record.operate2}`
          }
          return `${v} ${c1}${record.operate1}`
        }
        return ''
      }
    },
    {
      title: formatMessage({ id: 'app.template.alarm.table.address' }),
      key: 'app.template.alarm.table.address',
      render: (text: any, record: AlarmItem, index: any) => {
        const variable = props.variables?.find((x) => x.id == record.variableId)
        if (variable) {
          return getAddressName(variable, props.plcs)
        }
        return ''
      }
    },
    {
      title: formatMessage({ id: 'app.template.alarm.table.msg' }),
      key: 'app.template.alarm.table.msg',
      dataIndex: 'msg'
    },
    {
      title: formatMessage({ id: 'app.template.alarm.table.operation' }),
      key: 'app.template.plc.table.operation',
      render: (text: any, record: AlarmItem, index: any) => (
        <Space size='middle'>
          <a onClick={() => props.onEdit?.(record)}>
            {formatMessage({ id: 'app.template.alarm.table.operation.edit' })}
          </a>
          <a onClick={() => props.onDelete?.(record)}>
            {formatMessage({ id: 'app.template.alarm.table.operation.delete' })}
          </a>
        </Space>
      )
    }
  ]
  const columns = mergeTableColumns(defaultColumns, props.columns)

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      if (props.onSelect) {
        props.onSelect(selectedRows)
      }
    }
  }

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
      rowSelection={
        props.selectable
          ? {
              type: props.selectionType,
              ...rowSelection
            }
          : undefined
      }
    />
  )
}
